import { registerView, View, ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import * as React from "react";
import EshopViewModel from "viewModels/eshop/eshopViewModel";

const EshopView: ViewComponent<EshopViewModel> = observer(({ vm }) => <View vm={vm.activeChild} />);

registerView(EshopView, EshopViewModel);
